import {IntermediatePart} from "../../intermediatePart";
import {METADATA} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class BathTubBody extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_body";
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub.bathtub";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["BathType"]) {
      dbFeature.metaData["BathType"] = [METADATA.BathtubWithoutEnclosures]; // remove enclosure top and bottom
    }
    return super.load(dbFeature);
  }

  navigationSubItems(...props) {
    const [, , , , restOptions = {}] = props;
    const layout = this.getParent().layout;
    if (layout.type === 18) {
      restOptions.returnAllFeatures = true;
      const navItems = super.navigationSubItems(...props);
      return navItems.map(nItem => {
        nItem.notAvailableInVisualizer = true;
        nItem.part = nItem.part.clone();
        nItem.part.notAvailableInVisualizer = true;
        return nItem
      })
    }
    return super.navigationSubItems(...props);
  }

  disableReplacementTub() {
    const bathParent = this.getParent();
    const comboParent = bathParent.layout.parts[ShowerTubCombo.id];
    if (comboParent.freeStandingTubActive()) {
      comboParent.replacementTub.disabled = true;
    }
  }

  disabledClick() {
    const bathParent = this.getParent();
    if (!this.disabled) {
      this.disableReplacementTub();
    }
    ["bathTubFixture", "enclosureTop", "enclosureBottom"].forEach(relName => {
      if (bathParent[relName]) {
        bathParent[relName].disabled = this.disabled;
      }
    })
  }
}
